<template>
  <div class="bg-gray-50 min-h-screen">
    <!-- 面包屑导航 -->
    <section class="bg-white border-b">
      <div class="container mx-auto px-6 py-4">
        <nav class="text-sm text-gray-600 flex items-center">
          <router-link to="/" class="hover:text-primary transition-colors">Home</router-link>
          <i class="fa fa-angle-right mx-2 text-gray-400"></i>
          <router-link to="/news" class="hover:text-primary transition-colors">News</router-link>
          <i class="fa fa-angle-right mx-2 text-gray-400"></i>
          <span class="text-primary">{{ newsDetail.title }}</span>
        </nav>
      </div>
    </section>

    <!-- 新闻详情主内容 -->
    <section class="py-12">
      <div class="container mx-auto px-6">
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-10">
          <!-- 左侧主内容区 -->
          <div class="lg:col-span-3">
            <article class="bg-white rounded-lg shadow-md p-6 md:p-8">
              <!-- 新闻标题与元信息 -->
              <div class="mb-6">
                <!-- <span class="inline-block bg-primary/10 text-primary text-xs px-3 py-1 rounded-full mb-4">
                  {{ news.category }}
                </span> -->
                <h1 class="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
                  {{ newsDetail.title }}
                </h1>
                <div class="flex items-center text-gray-500 text-sm">
                  <div class="flex items-center mr-6">
                    <i class="fa fa-calendar-o mr-2"></i>
                    <span>{{ formatDate(newsDetail.pubTime) }}</span>
                  </div>
                  <!-- <div class="flex items-center">
                    <i class="fa fa-user-o mr-2"></i>
                    <span>By {{ news.author }}</span>
                  </div> -->
                </div>
              </div>

              <!-- 新闻主图 -->
              <div class="mb-8 rounded-lg overflow-hidden relative h-96">
                <img :src="newsDetail.coverOssUrl" :alt="newsDetail.title" class="w-full h-full object-cover transition-transform duration-500 hover:scale-110">
              </div>

              <!-- 新闻内容 -->
              <div class="prose prose-lg max-w-none text-gray-700 mb-8" v-html="newsDetail.content">

              </div>

              <!-- 标签与分享 -->
              <div class="pt-6 border-t border-gray-200">


                <div class="flex items-center justify-between">
                  <span class="text-gray-600">Share this article:</span>
                  <div class="flex gap-3">
                    <!-- Facebook分享 -->
                    <a href="#"
                      class="w-9 h-9 rounded-full bg-[#1877F2] flex items-center justify-center text-white hover:opacity-90 transition-opacity"
                      @click.prevent="shareToFacebook()">
                      <i class="fa fa-facebook"></i>
                    </a>
                    <!-- Twitter分享 -->
                    <a href="#"
                      class="w-9 h-9 rounded-full bg-[#1DA1F2] flex items-center justify-center text-white hover:opacity-90 transition-opacity"
                      @click.prevent="shareToTwitter()">
                      <i class="fa fa-twitter"></i>
                    </a>
                    <!-- LinkedIn分享 -->
                    <!-- <a href="#"
                      class="w-9 h-9 rounded-full bg-[#0A66C2] flex items-center justify-center text-white hover:opacity-90 transition-opacity"
                      @click.prevent="shareToLinkedIn()">
                      <i class="fa fa-linkedin"></i>
                    </a> -->
                    <!-- Pinterest分享 -->
                    <!-- <a href="#"
                      class="w-9 h-9 rounded-full bg-[#E60023] flex items-center justify-center text-white hover:opacity-90 transition-opacity"
                      @click.prevent="shareToPinterest()">
                      <i class="fa fa-pinterest"></i>
                    </a> -->
                    <!-- 复制链接 -->
                    <a href="#"
                      class="w-9 h-9 rounded-full bg-gray-700 flex items-center justify-center text-white hover:opacity-90 transition-opacity"
                      @click.prevent="copyLink()">
                      <i class="fa fa-link"></i>
                    </a>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { getNewsDetail } from '@/api/news'
// 获取当前路由参数（实际项目中可通过API根据ID获取数据）
const route = useRoute()
const newsId = ref(route.params.NewsId)
console.log(newsId.value)
onMounted(() => {
  getNewsDetailData()
})
const newsDetail = ref({})
const getNewsDetailData = async () => {
  try {
    // 调用接口，传入新闻 ID
    const res = await getNewsDetail(newsId.value)
    newsDetail.value = res.data // 假设接口返回的详情数据在 res.data 中
    console.log(newsDetail.value)
  } catch (error) {
    console.error('获取新闻详情失败：', error)
  }
}


// 日期格式化
const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' }
  return new Date(dateString).toLocaleDateString('en-US', options)
}
// 分享相关状态
const showToast = ref(false)
const toastMessage = ref('')
const toastIcon = ref('')
// 分享到Facebook
const shareToFacebook = () => {
  const shareUrl = window.location.href
  const title = newsDetail.value.title
  // const description = 'Economical wax ribbon with excellent label adaptability and high printing clarity'
  
  // Facebook官方分享链接
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(title)}`
  
  // 打开Facebook分享窗口
  window.open(facebookShareUrl, '_blank', 'width=600,height=400')
  showNotification('Opening Facebook share window...', 'fa fa-external-link text-blue-300')
}

// 分享到Twitter
const shareToTwitter = () => {
  const shareUrl = window.location.href
  const title = newsDetail.value.title
  const hashtags = 'ThermalTransferRibbon,LabelPrinting,BarcodeRibbon'
  
  // Twitter官方分享链接
  const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(title)}&hashtags=${encodeURIComponent(hashtags)}`
  
  // 打开Twitter分享窗口
  window.open(twitterShareUrl, '_blank', 'width=600,height=400')
  showNotification('Opening Twitter share window...', 'fa fa-external-link text-blue-300')
}

// 分享到LinkedIn
// const shareToLinkedIn = () => {
//   const shareUrl = window.location.href
//   const title = newsDetail.value.title
//   const summary = 'Economical wax ribbon with excellent label adaptability and high printing clarity - 24% discount now!'
  

//   const linkedInShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(summary)}`

//   window.open(linkedInShareUrl, '_blank', 'width=600,height=400')
//   showNotification('Opening LinkedIn share window...', 'fa fa-external-link text-blue-300')
// }

// 分享到Pinterest
// const shareToPinterest = () => {
//   const shareUrl = window.location.href
//   const title =  newsDetail.value.title

//   const pinterestShareUrl = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(shareUrl)}&description=${encodeURIComponent(title)}`

//   window.open(pinterestShareUrl, '_blank', 'width=600,height=600')
//   showNotification('Opening Pinterest share window...', 'fa fa-external-link text-red-300')
// }

// 复制产品链接
const copyLink = () => {
  const productUrl = window.location.href
  
  // 复制到剪贴板
  navigator.clipboard.writeText(productUrl)
    .then(() => {
      showNotification('Product link copied successfully!', 'fa fa-check-circle text-green-400')
    })
    .catch(err => {
      console.error('Failed to copy link:', err)
      showNotification('Failed to copy link', 'fa fa-exclamation-circle text-red-400')
    })
}
const showNotification = (message, icon) => {
  toastMessage.value = message
  toastIcon.value = icon
  showToast.value = true
  setTimeout(() => {
    showToast.value = false
  }, 2000)
}
</script>

<style scoped>
/* 内容样式优化 */
.prose p {
  line-height: 1.8;
}

/* 分享按钮样式 */
a:hover {
  transform: translateY(-2px);
  transition: transform 0.2s ease;
}

/* 相关新闻hover效果 */
.group .line-clamp-2 {
  transition: color 0.2s ease;
}

/* 响应式调整 */
@media (max-width: 1024px) {

  .lg\:col-span-2,
  .lg\:col-span-1 {
    width: 100%;
  }
}

.prose p {
  line-height: 1.8;
}

/* 分享按钮样式 */
a:hover {
  transform: translateY(-2px);
  transition: transform 0.2s ease;
}

/* 相关新闻hover效果 */
.group .line-clamp-2 {
  transition: color 0.2s ease;
}

/* 响应式调整 */
@media (max-width: 1024px) {

  .lg\:col-span-2,
  .lg\:col-span-1 {
    width: 100%;
  }
}

/* 关键：穿透scoped，设置富文本内的图片样式 */
/* 方案1：使用 ::v-deep（兼容Vue 2/3） */
::v-deep .prose img {
  width: 100% !important;
  /* 强制100%宽度 */
  max-width: 100%;
  /* 防止超出容器 */
  height: auto !important;
  /* 保持宽高比 */
  border-radius: 8px;
  /* 可选：添加圆角，和页面风格统一 */
  object-fit: cover;
  /* 可选：图片适配容器 */
  margin: 1.5rem 0;
  /* 可选：上下间距，提升排版美观度 */
}

/* 方案2：使用 :deep()（Vue 3 推荐写法，二选一即可） */
/* :deep(.prose img) {
  width: 100% !important;
  max-width: 100%;
  height: auto !important;
  border-radius: 8px;
  margin: 1.5rem 0;
} */

/* 可选：优化富文本其他元素的排版 */
::v-deep .prose {
  max-width: 100% !important;
  /* 取消prose默认宽度限制 */
}

::v-deep .prose img:hover {
  opacity: 0.95;
  /* 可选：hover 轻微透明效果 */
  transition: opacity 0.2s ease;
}

/* 移动端图片优化 */
@media (max-width: 640px) {
  ::v-deep .prose img {
    margin: 1rem 0;
    /* 移动端减小上下间距 */
    border-radius: 4px;
    /* 移动端圆角适配 */
  }
}
</style>